import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";

customerAddressFormFieldStyles.attentionGridItem = { width: 12 };
